import { render, staticRenderFns } from "./SectionTitle.vue?vue&type=template&id=71852e49&scoped=true&"
import script from "./SectionTitle.vue?vue&type=script&lang=ts&"
export * from "./SectionTitle.vue?vue&type=script&lang=ts&"
import style0 from "./SectionTitle.vue?vue&type=style&index=0&id=71852e49&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71852e49",
  null
  
)

export default component.exports